module.exports = __webpack_public_path__ + "static/media/Jtinn.41dea5a1.webp";